module.exports = __webpack_public_path__ + "static/media/Letra_Caixa (7).80918b4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/Letra_Caixa (7).jpg
// module id = 346
// module chunks = 0